module.exports = __webpack_public_path__ + "img/5.7b3442c6.svg";